import App from "./components/App";
import * as  ReactDOM from "react-dom";
import * as React from "react";

require('./bootstrap');

export interface IWindow extends Window {
    pageComponent: string,
    initialState: {
        user: any
        permissions: any
        route: {
            params: any,
        },
        react_token: string
    }
}

if (document.getElementById('react-app')) {
    ReactDOM.render(<App/>, document.getElementById('react-app'));
}



// WEBPACK FOOTER //
// ./resources/js/index.tsx